export enum CheckNotificationTypeNamesEnum {
  HAS_PLANS_IN_PROCESS = 'Уведомление об отправке плана на согласование',
  HAS_PLANS_IN_PROCESS_OR_UNDER_CONSIDERATION = 'Уведомление о рассмотрении плана',
  HAS_PLANS_NOT_APPROVED = 'Уведомление об отправке плана на утверждение',
  HAS_UPDATE_2023_07_28 = 'Уведомление об обновлении',
  GENERAL_PROSECUTOR_ADDED = 'Уведомление',
  FOR_CREATE_KNM_WITH_GENERAL_PROSECUTOR = 'Уведомление',
  FOR_CREATE_PLAN_WITH_GENERAL_PROSECUTOR = 'Уведомление',
  NONE = '',
}
